import { toast } from 'react-toastify';

export const showToast = (message) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    theme: 'dark',
    style: {
      backgroundColor: '#1E293B',
    },
  });
};

export const errorToast = (message) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    theme: 'dark',
    style: {
      backgroundColor: '#1E293B',
    },
  });
};
